import React from 'react';

import classes from './MapLayersOptions.module.scss';
import { IPickedLayer, LayersTypes } from '../MapLayers.model';
import { IMapLayers } from './MapLayersOptions.model';
import MIcon from 'views/MIcon/MIcon';

type Props = {
  layersItems: IMapLayers[];
  pickedLayer: IPickedLayer | null;
  layerTypeOptions?: LayersTypes;
  onEnterMapLayer: () => void;
  onLeaveMapLayer: () => void;
  onClickLayer: (layer: LayersTypes | null) => void;
};

const MapLayersOptionsView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <div onMouseEnter={props.onEnterMapLayer} onMouseLeave={props.onLeaveMapLayer} className={classes['layetsOptionWrapper']}>
      {props.layersItems.map((layerItem: IMapLayers, index: number) => {
        return (
          <div onClick={() => props.onClickLayer(layerItem.type === props.pickedLayer?.type ? null : layerItem.type)} className={classes['layerItem']} key={index}>
            <div className={`${classes['square']}  ${layerItem.type === props.pickedLayer?.type ? classes['square--picked'] : ''}`}>
              <MIcon className={`${classes['icon']} ${classes[`icon--${layerItem.name?.toLowerCase()}`]}`} name={layerItem.icon}></MIcon>
            </div>
            <div className={classes['name']}>{layerItem.title}</div>
          </div>
        );
      })}
    </div>
  );
};

MapLayersOptionsView.displayName = 'MapLayersOptionsView';
MapLayersOptionsView.defaultProps = {};

export default MapLayersOptionsView;
